var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 1c.529 0 .987.21 1.354.58l2.068 2.067c.37.37.578.826.578 1.353 0 .524-.206 1.067-.578 1.44L6.89 13.967c-.523.604-1.266.976-2.134 1.035H1v-1l.003-2.837c.064-.79.43-1.523.979-2.005L9.561 1.58A2.06 2.06 0 0 1 11 1m-7.648 9.616c-.206.182-.333.436-.352.63v1.756l1.686.002c.268-.019.517-.144.741-.399L9.81 8.224 7.778 6.192zm5.84-5.838 2.031 2.031 1.766-1.766-2.03-2.03z",
    clipRule: "evenodd"
  })));
};
export default SvgPencil;